<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Paula is a survivor of domestic violence and has drawn on her experiences to produce a powerful and heartbreaking account of living with intimate partner violence. A loving wife to her husband Scott and mother to three adult sons. Paula has spent many years working in the disability field. Creating this novel was a long-held dream for Paula but it was also one that came at significant personal cost, as the writing process compelled her to face and process the trauma she had experienced as a young woman.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?75e8cf43